import { Conversation } from "./conversation";
import { ApiError, IAPIKey, IState } from '../chatbot/api/llmapi';
import { ModelList } from './modellist';
import { TOAST_TYPES, ToastManager } from "./toastmanager";

type ThreadUpdatedCallback = (status : IState) => void;

export class Users
{
    static callbacks : Set<ThreadUpdatedCallback> = new Set<ThreadUpdatedCallback>();

    static async changePassword(email : string, password : string, token : string, payload : string) : Promise<void>
    {
        await Conversation.api.changePassword!(email, password, token, payload);
        Users.getState();
    }

    static async createAccount(username : string, password : string, altcha : string) 
    {
        await Conversation.api.createAccount!(username, password, altcha);
    }

    static async createApiKey(name : string) : Promise<IAPIKey>
    {
        return await Conversation.api.createApiKey!(name);
    }

    static async deleteAPIKey(shortToken : string) : Promise<void>
    {
        return await Conversation.api.deleteAPIKey!(shortToken);
    }

    static async forgotPassword(email : string, altcha : string) : Promise<void>
    {
        return Conversation.api.forgotPassword!(email, altcha);
    }

    static async getState() : Promise<IState>
    {
        const isPrerendering = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
        if (isPrerendering) {
            return {
                playgroundRunning : true
            };
        }

        try {
            const status = await Conversation.api.getState!();
            Users.callbacks.forEach(callback => {
                callback(status);
            });
            ModelList.reloadModelList(status.user !== undefined);

            if (status.user !== undefined) Conversation.fetchUserCredits(true);
            return status;
        } catch (error) {
            console.error('Failed to get state:', error);
            return {
                playgroundRunning : false
            };
        }
    }

    static async login(email : string, password : string, altcha : string) : Promise<void>
    {
        await Conversation.api.login!(email, password, altcha);
        Users.getState();
    }

    static async logout() : Promise<void>
    {
        try {
            await Conversation.api.logout!();
            this.getState();
            return;
        }
        catch(error) {
            console.log(error);
        }
    }

    static onUpdate(updateHandler : ThreadUpdatedCallback)
    {
        Users.callbacks.add(updateHandler);
    }

    static async verify(email : string, password : string, emailCode : string, altcha : string)
    {
        await Conversation.api.verify!(email, password, emailCode, altcha);
    }

    static async getCheckout(amount: number) {
        try {
            let result = await Conversation.api.getCheckout!(amount);
            window.location.href = result.checkoutUrl;
        }catch (error) {
            if (error instanceof ApiError) {
                ToastManager.addToast(error.message, TOAST_TYPES.ERROR, 5000);
            } else {
                console.error(error);
            }
        }
    }

    static async getPaymentStatus(checkoutId: string) {
        return await Conversation.api.getPaymentStatus!(checkoutId);
    }

    static async getUserCredits() {
        return await Conversation.fetchUserCredits(false);
    }
}

